import { render, staticRenderFns } from "./LogigramOption.vue?vue&type=template&id=175932a1&"
import script from "./LogigramOption.vue?vue&type=script&lang=js&"
export * from "./LogigramOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports